import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getReportDetails } from "../../Services/Reports";
import { format_date, getDriverDisplayName } from "../../Utils/helpers";
import { image_url } from "../../Utils/connection_strings";
import BackButton from "../../Components/BackButton";
import ModalImageViewer from "../../Components/ModalImageViewer";

export default function ReportDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [report, setReport] = useState({});
  const [showViewer, setShowViewer] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);

  const { data, isLoading, refetch } = useQuery(["report_details", id], () =>
    getReportDetails(id)
  );

  useEffect(() => {
    if (data?.data?.data?.docs?.length > 0)
      setReport(data?.data?.data?.docs?.[0]);
  }, [data?.data?.data?.docs]);

  const imagesList = report?.images?.map(img => img?.imageUrl || `${image_url}${img}`) || [];

  const handleImageClick = (index) => {
    setViewerIndex(index);
    setShowViewer(true);
  };

  return (
    <div className="app-content content dashboard">
      <div className="content-wrapper">
        <div className="content-body">
          <section id="configuration">
            <div className="row">
              <div className="col-12">
                <div className="user-details-wrapper">
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="back-title d-flex align-items-center">
                        <BackButton />
                        <h1 className="pageTitle m-0 ms-3 fw-800">Report Details</h1>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <Link
                      to={`/ride-management/ride-details/${report?.bookingId?._id}`}
                      className="siteBtn2"
                    >
                      View Booking
                    </Link>
                  </div>

                  <div className="row mb-3">
                    <div className="col-12">
                      <div className="details-card-premium p-4 p-lg-5 bg-white rounded-4 shadow-sm border">
                        <div className="row">
                          <div className="col-xxl-8">
                            {[
                              { label: "Reported By:", value: report?.reportedBy?.firstName || "-" },
                              { label: "Email Address:", value: report?.reportedBy?.email || "-" },
                              { label: "Driver Name:", value: getDriverDisplayName(report?.bookingId?.driver, "-") },
                              { label: "Driver Email Address:", value: report?.bookingId?.driver?.email || "-" },
                              { label: "Type:", value: report?.type || "-" },
                              { label: "Date Submitted:", value: report?.createdAt ? format_date(report?.createdAt, "DD/MM/YYYY") : "-" },
                              { label: "Broken Item Cost:", value: report?.brokenItemCost ? `$${report?.brokenItemCost}` : "-" },
                              { label: "Description:", value: report?.details || "-" },
                            ].map((item, index) => (
                              <div key={index} className={`mainDetail d-xl-flex align-items-baseline ${index === 7 ? 'border-0' : ''}`}>
                                <label className="mainLabel fw-semibold text-secondary" style={{ minWidth: "250px" }}>{item.label}</label>
                                <p className="mainText fw-bold text-dark">{item.value}</p>
                              </div>
                            ))}

                            {/* Images Section */}
                            {imagesList.length > 0 && (
                              <div className="mainDetail d-block border-0 mt-4">
                                <label className="mainLabel fw-semibold text-secondary mb-3 d-block">Images:</label>
                                <div className="d-flex flex-wrap gap-3">
                                  {imagesList.map((img, index) => (
                                    <div
                                      key={index}
                                      onClick={() => handleImageClick(index)}
                                      style={{ cursor: "pointer" }}
                                      className="image-hover-wrapper"
                                    >
                                      <img
                                        src={img}
                                        alt={`report-${index}`}
                                        className="rounded-3 shadow-sm border"
                                        style={{
                                          width: "120px",
                                          height: "120px",
                                          objectFit: "cover",
                                          transition: "transform 0.2s"
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <ModalImageViewer
        show={showViewer}
        images={imagesList}
        startIndex={viewerIndex}
        onHide={() => setShowViewer(false)}
        title="Report Images"
      />
    </div>
  );
}
